import React from 'react';

import { type CardSizes } from '@pkg/components';
import { ChipColor } from '@pkg/components/Sections/Profile/Chip';
import { ChipMember } from '@pkg/components/Sections/Profile/Chips/ChipMember';

import { Wrapper } from './styles';

interface YatUsernameProps {
    yat?: string | null;
    twitter?: string | null;
    cardSize?: CardSizes;
}

export const YatUsername = ({ yat, twitter, cardSize }: YatUsernameProps) => {
    if (!yat) return null;

    return (
        <Wrapper>
            <ChipMember
                yat={yat || undefined}
                twitter={twitter || undefined}
                to={yat ? `/${yat}` : undefined}
                size={cardSize === 'large' ? 'small' : 'smaller'}
                color={ChipColor.BorderTransparent}
            />
        </Wrapper>
    );
};
